import { useIntl } from 'react-intl';

import { ChipPreset } from '../../types/ChipPreset';

export const usePreset = (preset?: ChipPreset) => {
  const intl = useIntl();

  if (!preset) {
    return {};
  }

  switch (preset) {
    case 'ai':
      return {
        icon: 'ai' as const,
        status: 'ai' as const,
      };
    case 'beta':
      return {
        status: 'new' as const,
        text: intl.formatMessage({
          id: 'Chip.betaText',
          defaultMessage: 'BETA',
          description: 'Text for beta chip',
        }),
      };
    case 'error':
      return {
        icon: 'status-danger' as const,
        status: 'danger' as const,
      };
    case 'inactive':
      return {
        icon: 'status-inactive' as const,
        status: 'inactive' as const,
      };
    case 'info':
    case 'removable':
      return {
        status: 'info' as const,
      };
    case 'loading':
      return {
        icon: 'loading' as const,
        status: 'info' as const,
      };
    case 'new':
      return {
        icon: 'status-new' as const,
        status: 'new' as const,
        text: intl.formatMessage({
          id: 'Chip.newText',
          defaultMessage: 'NEW',
          description: 'Text for new chip',
        }),
      };
    case 'pending':
      return {
        icon: 'status-pending' as const,
        status: 'warning' as const,
      };
    case 'success':
      return {
        icon: 'status-success' as const,
        status: 'success' as const,
      };
    default:
      return {};
  }
};
